export default "__VITE_PUBLIC_ASSET__d33d1c93__"